import styled from '@emotion/styled';

export const Flex = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
  flex-grow: ${({ grow }) => grow || 0};
  align-items: ${({ alignment }) => alignment || 'stretch'};
  justify-content: ${({ spacing }) => spacing || 'flex-start'};
`;

export const FlexVertical = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
`;
